import * as ax from "../instrance";
import config from "../../../config/config.js";
var URL = config.apiUrl;


//门户端

//获取商铺list
export const getSubscriptionsList = params => {
  return ax.pJson(URL + "/jeecg-boot/portal-service/portal/getSubscriptionsList", params);
};

//获取商铺信息和评论列表
export const getSubDataAndPJList = params => {
  return ax.pJson(URL + "/jeecg-boot/portal-service/portal/getSubDataAndPJList", params);
};

//发布评价
export const addComment = params => {
  return ax.pJson(URL + "/jeecg-boot/portal-service/portal/addComment", params);
};
//删除评价
export const delComment = params => {
  return ax.pJson(URL + "/jeecg-boot/portal-service/portal/delComment", params);
};
//回复评价
export const addReply = params => {
  return ax.pJson(URL + "/jeecg-boot/portal-service/portal/addReply", params);
};
//获取登录验证码
export const getVerCode = params => {
  return ax.pJson(URL + "/jeecg-boot/back-service/interface/getVerCode3", params);
};
//获取注册验证码
export const getVerCode1 = params => {
  return ax.pJson(URL + "/jeecg-boot/back-service/interface/getVerCode1", params);
};
//注册
export const addNewUser = params => {
  return ax.pJson(URL + "/jeecg-boot/back-service/interface/addNewUser1", params);
};
//验证码登录
export const loginVerCode = params => {
  return ax.pJson(URL + "/jeecg-boot/back-service/interface/loginVerCode", params);
};
//用户登录
export const userLogin = params => {
  return ax.pJson(URL + "/jeecg-boot/back-service/interface/userLogin1", params);
};





// WEBPACK FOOTER //
// ./src/api/portal-api/portal.js